import { render, staticRenderFns } from "./CoursesViewTabLessons.vue?vue&type=template&id=464ec4f0"
import script from "./CoursesViewTabLessons.vue?vue&type=script&lang=js"
export * from "./CoursesViewTabLessons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports